import { i18n } from "@lingui/core";
import { t } from "@lingui/macro";
import { memo, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { Route, Routes, useParams } from "react-router-dom";

import { TenantEnum } from "../../api";
import { receiveUsersAction } from "../../store/users/actions";
import { UsersFilter } from "./models";
import UserDetailContainer from "./UserDetailContainer";
import UsersListContainer from "./UsersListContainer";

const initialFilter: UsersFilter = {
  search: "",
  organisationCode: "",
};

const UsersContainer = memo(() => {
  const dispatch = useDispatch();

  let { tenant } = useParams();

  // Now validate that the tenant in the route has been set with a proper value, fallback value is national.
  tenant =
    TenantEnum.Regional.localeCompare(tenant as TenantEnum, undefined, {
      sensitivity: "base",
    }) === 0
      ? TenantEnum.Regional
      : TenantEnum.National;

  const [filter, setFilter] = useState(initialFilter);

  useEffect(() => {
    dispatch(receiveUsersAction.request());
    setFilter(initialFilter);
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{i18n._(t`Gebruikers`)}</title>
      </Helmet>

      <Routes>
        <Route
          path="/new"
          element={
            <UserDetailContainer
              tenant={tenant as TenantEnum}
              setFilter={setFilter}
            />
          }
        />
        <Route
          path="/:userId"
          element={
            <UserDetailContainer
              tenant={tenant as TenantEnum}
              setFilter={setFilter}
            />
          }
        />
        <Route
          path="/"
          element={
            <UsersListContainer
              setFilter={setFilter}
              tenant={tenant as TenantEnum}
              filter={filter}
            />
          }
        />
      </Routes>
    </>
  );
});

export default UsersContainer;
